import { render, staticRenderFns } from "./Slide2.vue?vue&type=template&id=0345f31c&scoped=true&"
import script from "./Slide2.vue?vue&type=script&lang=js&"
export * from "./Slide2.vue?vue&type=script&lang=js&"
import style0 from "./Slide2.vue?vue&type=style&index=0&id=0345f31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345f31c",
  null
  
)

export default component.exports